import { useDateFormatter, useTranslations } from "../../contexts/Translation";
import { H1 } from "../Headers";
import Section from "../Section";
import SystemMessage from '../../components/SystemMessage/Index';
import { useState } from "react";
import { Edit } from "../Icons";
import { IconButton } from "../Button";
import { useProfile } from "../../contexts/UserProvider";
import { useImprovementGoal } from "../../contexts/ImprovementGoal";
import { InfoItem } from "../Survey/InfoItem";
import HorizontalNavigation from "../HorizontalNavigation/Index";
import InitialPhase from "./InitialPhase";
import ExecutionPhase from "./ExecutionPhase";
import ConclusionPhase from "./ConclusionPhase";
import Link from "../Link";
import ConclusionFlag from "./ConclusionFlag";

const ImprovementGoalDetails = ({ isShared = false }) => {
  const t = useTranslations('improvementGoals');
  const d = useDateFormatter();
  const { goal } = useImprovementGoal();
  const profile = useProfile();
  const [isEdit, setIsEdit] = useState(false);

  if (!goal) {
    return <SystemMessage message="loading" />;
  }

  const labels = [t('phasesInitial'), t('phasesExec'), t('phasesConclusion')];
  const pages = [
    <InitialPhase isEdit={isEdit} />,
    <ExecutionPhase />,
    <ConclusionPhase isEdit={isEdit} />
  ];

  const getStartPageForStatus = () => {
    if (goal.status === 'planning') { return 0; }
    if (goal.status === 'execution') { return 1; }
    return 2;
  };

  return (
      <Section>
        <H1>{ goal.name || t('goalHeading')} <ConclusionFlag isSuccess={goal.isSuccess} />
          { goal.userId === profile?.userId && <IconButton sx={{ border: 'none', color: isEdit ? 'primary' : 'mainText'}} onClick={() => setIsEdit(!isEdit)}><Edit /></IconButton> }
        </H1>
        
        { goal.registered && <InfoItem>{t('registeredLabel', d(goal.registered))}</InfoItem> }
        <InfoItem>{t('endDateLabel', d(goal.endDate))}</InfoItem>
        <InfoItem><Link href={isShared ? `/shared/${goal.originalSurvey}`: `/survey/${goal.originalSurvey}`}>{t('originalSurvey')}</Link></InfoItem>
        <InfoItem>{t(`status_${goal.status}`)}</InfoItem>
        <HorizontalNavigation labels={labels} pages={pages} start={getStartPageForStatus()} />
      </Section>
  );
};

export default ImprovementGoalDetails;
